"use client";
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';
import { getUserSubPlan } from '../subscription';

/**
 * 执行顺序的问题，在useEffect中使用 useSubPlan 的返回值时，可能还没有初始化
 * 建议明确判断true/false/undefined
 */
export function useSubPlanCode() {
  const [subPlanCode, setSubPlanCode] = useState<string | undefined>(undefined);
  const pathname = usePathname();

  useEffect(() => {
    const getSubPlan = async () => {
      const sub = await getUserSubPlan();
      setSubPlanCode(sub?.plan?.code);
    };
    getSubPlan();
  }, [pathname]);

  return subPlanCode; // 返回状态值（可能为 null | string）
}

